import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
export function PublishStatus({ published }) {
    const { t } = useTranslation();
    return (_jsx("div", { className: clsx('rounded-large border-small px-2 text-extrasmall md:!col-[5]', {
            'border-warning-500 bg-warning-100 text-warning-500': !published,
            'border-success-500 bg-success-100 text-success-500': published
        }), children: published ? t('general.published') : t('content_list.page_card.draft') }));
}
